import { Routes } from '@angular/router';
import { authGuard, publicGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then(m => m.Login),
    canActivate: [publicGuard]
  },
  {
    path: 'logout',
    loadComponent: () => import('./pages/logout/logout').then(m => m.Logout)
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard').then(m => m.Dashboard),
    canActivate: [authGuard]
  },
  {
    path: 'members',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
      },
      {
        path: 'list',
        loadComponent: () => import('./pages/users/user-list/user-list').then(m => m.UserList)
      },
      {
        path: 'add',
        loadComponent: () => import('./pages/users/user-add/user-add').then(m => m.UserAdd)
      },
      {
        path: 'invite',
        loadComponent: () => import('./pages/users/user-invite/user-invite').then(m => m.UserInvite)
      },
      {
        path: 'view/:id',
        loadComponent: () => import('./pages/users/user-view/user-view').then(m => m.UserView)
      }
    ]
  },
  {
    path: 'onboarding',
    canActivate: [authGuard],
    children: [
      {
        path: 'questions',
        loadComponent: () => import('./pages/onboarding/question-list/question-list').then(m => m.QuestionList)
      },
      {
        path: 'questions/create',
        loadComponent: () => import('./pages/onboarding/question-form/question-form').then(m => m.QuestionForm)
      },
      {
        path: 'questions/edit/:id',
        loadComponent: () => import('./pages/onboarding/question-form/question-form').then(m => m.QuestionForm)
      },
      {
        path: 'avatars',
        loadComponent: () => import('./pages/onboarding/avatar-list/avatar-list').then(m => m.AvatarList)
      },
      {
        path: 'avatars/add',
        loadComponent: () => import('./pages/onboarding/avatar-form/avatar-form').then(m => m.AvatarForm)
      },
      {
        path: 'avatars/edit/:id',
        loadComponent: () => import('./pages/onboarding/avatar-form/avatar-form').then(m => m.AvatarForm)
      }
    ]
  },
  {
    path: 'check-in',
    canActivate: [authGuard],
    children: [
      {
        path: 'emotions',
        loadComponent: () => import('./pages/check-in/emotion-list/emotion-list').then(m => m.EmotionList)
      },
      {
        path: 'emotions/add',
        loadComponent: () => import('./pages/check-in/emotion-form/emotion-form').then(m => m.EmotionForm)
      },
      {
        path: 'emotions/edit/:id',
        loadComponent: () => import('./pages/check-in/emotion-form/emotion-form').then(m => m.EmotionForm)
      },
      {
        path: 'social-networks',
        loadComponent: () => import('./pages/check-in/social-network-list/social-network-list').then(m => m.SocialNetworkList)
      },
      {
        path: 'social-networks/add',
        loadComponent: () => import('./pages/check-in/social-network-form/social-network-form').then(m => m.SocialNetworkForm)
      },
      {
        path: 'social-networks/edit/:id',
        loadComponent: () => import('./pages/check-in/social-network-form/social-network-form').then(m => m.SocialNetworkForm)
      },
      {
        path: 'reasons',
        loadComponent: () => import('./pages/check-in/reason-list/reason-list').then(m => m.ReasonList)
      },
      {
        path: 'reasons/add',
        loadComponent: () => import('./pages/check-in/reason-form/reason-form').then(m => m.ReasonForm)
      },
      {
        path: 'reasons/edit/:id',
        loadComponent: () => import('./pages/check-in/reason-form/reason-form').then(m => m.ReasonForm)
      },
      {
        path: 'usage-reasons',
        loadComponent: () => import('./pages/check-in/usage-reason-list/usage-reason-list').then(m => m.UsageReasonList)
      },
      {
        path: 'usage-reasons/add',
        loadComponent: () => import('./pages/check-in/usage-reason-form/usage-reason-form').then(m => m.UsageReasonForm)
      },
      {
        path: 'usage-reasons/edit/:id',
        loadComponent: () => import('./pages/check-in/usage-reason-form/usage-reason-form').then(m => m.UsageReasonForm)
      }
    ]
  },
  {
    path: 'instead',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'habits',
        pathMatch: 'full'
      },
      {
        path: 'habits',
        loadComponent: () => import('./pages/instead/habit-list/habit-list').then(m => m.HabitList)
      },
      {
        path: 'habits/add',
        loadComponent: () => import('./pages/instead/habit-form/habit-form').then(m => m.HabitForm)
      },
      {
        path: 'habits/edit/:id',
        loadComponent: () => import('./pages/instead/habit-form/habit-form').then(m => m.HabitForm)
      },
      {
        path: 'poll',
        loadComponent: () => import('./pages/instead/poll-form/poll-form').then(m => m.PollForm)
      }
    ]
  },
  {
    path: 'insights',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/insights/insight-list/insight-list').then(m => m.InsightList)
      },
      {
        path: 'create',
        loadComponent: () => import('./pages/insights/insight-form/insight-form').then(m => m.InsightForm)
      },
      {
        path: 'edit/:id',
        loadComponent: () => import('./pages/insights/insight-form/insight-form').then(m => m.InsightForm)
      }
    ]
  }
];
